module.exports = __webpack_public_path__ + "static/media/014.0c883783.jpg";